import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';

@Component({
	selector: 'graduation-mark-all-graduated-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './mark-all-graduated.dialog.html',
})
export class MarkAllGraduatedDialog {

	public dialog: DialogContext<{}> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<MarkAllGraduatedDialog>);

	public accAreaService = inject(AcceleratorAreaService);
	public util = inject(UtilityService);
	public dialogService = inject(DialogService);

	public actions: DialogAction[] = [
		{
			id: 'save',
			cssClass: signal('btn-primary'),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Mark Graduated'),
			linkType: 'callback',
			callback: async () => this.markGraduated(),
			willCloseDialog: true,
		},
		{
			id: 'close',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: "no-action",
			willCloseDialog: true,
		}
	];

	public entrepreneurs = computed(() => {
		const data = this.accAreaService.data();
		if (!data) return [];

		const venturesById = this.util.array.toMap(data.ventures.filter(v => v.status === 'Participating'), v => v.accVentureId);

		const allEntrepreneurs = data.entrepreneurs.map(e => {
			const venture = venturesById[e.accVentureId];

			// if there is no venture or the venture is not participating, we shouldn't show the entrepreneur
			if (!venture) return undefined;

			return {
				name: e.fullName,
				accVentureId: e.accVentureId,
				ventureName: venture.ventureName,
			}
		}).filter(e => e !== undefined);

		if (allEntrepreneurs.length < 2) {
			return [allEntrepreneurs];
		}

		// If there are 2 or more entrepreneurs, split them into two arrays for display purposes
		const half = Math.ceil(allEntrepreneurs.length / 2);
		return [
			allEntrepreneurs.slice(0, half),
			allEntrepreneurs.slice(half)
		];
	});

	private async markGraduated() {
		const yes = await this.dialogService.confirm(`Are you sure you want to mark all ventures listed as 'Graduated'? This cannot be undone.`, 'Yes', 'No', [], 400, 200);

		if (yes) {
			await this.accAreaService.markVenturesGraduated(this.entrepreneurs().flat().map(e => e.accVentureId));
		}
	}
}
